<template>
  <div>
    <template-item layout="flex" label="生成的项">
      <el-radio-group v-model="value">
        <el-radio :label="1">省</el-radio>
        <el-radio :label="2">市</el-radio>
        <el-radio :label="3">县</el-radio>
      </el-radio-group>
    </template-item>
    <div v-if="value === 1">
      <sequence-province-selector :data-source="provinceSource" />
    </div>
    <div v-if="value === 2">
      <sequence-city-selector :provinces="provinceSource" />
    </div>
    <div v-if="value === 3">
      <sequence-county-selector :provinces="provinceSource" />
    </div>
    <el-divider />
    <template-item layout="flex" label="填写类型">
      <value-type-selector v-model="valueType" />
    </template-item>
    <template-item
      v-if="valueType !== undefined && valueType !== null"
      label="填写方式"
    >
      <value-mode-selector v-model="answerType" :modes="modes" />
    </template-item>
    <template-item v-if="answerType === 1 || answerType === 2" label="备选项"
      ><el-table border>
        <el-table-column label="值" property="value" />
        <el-table-column label="显示文本" property="text" />
      </el-table>
    </template-item>
  </div>
</template>
<script>
import { RadioGroup, Radio } from "element-ui";
import { Divider, Table, TableColumn } from "element-ui";
import SequenceProvinceSelector from "@/components/excel/designer/template/area/sequence/ProvinceSelector";
import SequenceCitySelector from "@/components/excel/designer/template/area/sequence/CitySelector";
import SequenceCountySelector from "@/components/excel/designer/template/area/sequence/CountySelector";
import ValueTypeSelector from "@/components/excel/designer/template/value/ValueTypeSelector";
import ValueModeSelector from "@/components/excel/designer/template/value/ValueModeSelector";
import { findModes } from "@/components/excel/schema/label/type";
import TemplateItem from "@/components/excel/designer/template/TemplateItem";
import { AreaSharedCache } from "@/utils/AreaSharedCache";
export default {
  name: "sequence-area",
  components: {
    TemplateItem,
    ValueModeSelector,
    ValueTypeSelector,
    SequenceCitySelector,
    SequenceCountySelector,
    SequenceProvinceSelector,
    [RadioGroup.name]: RadioGroup,
    [Divider.name]: Divider,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
  },
  computed: {
    modes() {
      return findModes(this.valueType);
    },
  },
  data() {
    return {
      value: 2,
      valueType: null,
      answerType: 5,
      provinceSource: [],
    };
  },
  mounted() {
    AreaSharedCache.loadChildren(0).then(
      (it) => (this.provinceSource = it || [])
    );
  },
};
</script>
